import ENV from "config/Env";
import { permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { PIN_ORDER_STATUSES, PIN_STATUSES, PIN_TYPES, WARRANTY_TYPES } from "models";

const component = "PinModal";

export type PinOptions<T extends PIN_ORDER_STATUSES | PIN_TYPES | PIN_STATUSES | WARRANTY_TYPES> = {
  id: T;
  name: string;
  label: string;
};

export type PinDropdownOptions = {
  pin_types: PinOptions<PIN_TYPES>[] | null;
  pin_statuses: PinOptions<PIN_STATUSES>[] | null;
  warranty_types: PinOptions<WARRANTY_TYPES>[] | null;
  pin_order_statuses: PinOptions<PIN_ORDER_STATUSES>[] | null;
};

export const PinModalKeys = {
  dropdownsOptions: permanentBackendQueryKey<PinDropdownOptions>({ component, endpoint: "/pins/list_options", baseUrl: ENV.appointmentBaseURL })
};
